var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product" },
    _vm._l(_vm.productList, function(item, index) {
      return _c("div", { key: index, staticClass: "li" }, [
        _c(
          "a",
          {
            staticClass: "item a-link",
            on: {
              click: function($event) {
                return _vm.toProductDetail(item)
              }
            }
          },
          [
            _c("div", { staticClass: "itemImgBox" }, [
              _c("div", { staticClass: "imgBox" }, [
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: item.image,
                      expression: "item.image"
                    }
                  ],
                  attrs: { src: item.image, alt: item.productName }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              item.shopType
                ? _c("h4", { staticClass: "h4" }, [
                    _c(
                      "span",
                      {
                        staticClass: "xhnTextLogo",
                        staticStyle: { "margin-top": "-1px" }
                      },
                      [_vm._v("自营")]
                    ),
                    _vm._v(
                      "\n          " + _vm._s(item.productName) + "\n        "
                    )
                  ])
                : _c("h4", { staticClass: "h4" }, [
                    _vm._v(_vm._s(item.productName))
                  ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "priceBox",
                  staticStyle: { "margin-left": "0" }
                },
                [
                  _c("span", [
                    _c("small", { staticStyle: { "margin-right": "4px" } }, [
                      _vm._v("¥")
                    ]),
                    _vm._v(
                      "\n            " + _vm._s(item.price) + "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "shopName",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.goStore(item)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "icon-dianputoubu" }),
                      _c("span", [_vm._v(_vm._s(item.shopName))])
                    ]
                  )
                ]
              )
            ])
          ]
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-53bcd87f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-53bcd87f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/base/productList.vue
// module id = null
// module chunks = 